// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const apiCallsSlice = createSlice({
    name: 'apiCalls',
    initialState: {
        loading: {},
        errors: {},
    },
    reducers: {
        requestStarted(state, action) {
            const { key } = action.payload;
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [key]: true,
                },
                errors: {
                    ...state.errors,
                    [key]: null,
                },
            };
        },
        requestSucceeded(state, action) {
            const { key } = action.payload;
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [key]: false,
                },
                errors: {
                    ...state.errors,
                    [key]: null,
                },
            };
        },
        requestFailed(state, action) {
            const { key, error } = action.payload;
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [key]: false,
                },
                errors: {
                    ...state.errors,
                    [key]: error,
                },
            };
        },
    },
});

export const { requestStarted, requestSucceeded, requestFailed } = apiCallsSlice.actions;

export default apiCallsSlice;
